import CancelIcon from '@mui/icons-material/Cancel';
import DeleteIcon from '@mui/icons-material/Delete';
import { createPortal } from 'react-dom';
import Button from '@/trio-ui/Button';
import * as Styles from './DialogBox.styles';

export type DialogBoxProps = {
  onConfirmHandler: () => void;
  onCancelHandler: () => void;
  isOpen: boolean;
  bodyText?: string;
  title?: string;
  isSubmitting?: boolean;
};

const DialogBox = ({
  isOpen,
  isSubmitting,
  bodyText = 'This action cannot be undone.',
  title = 'Are you sure?',
  onCancelHandler,
  onConfirmHandler,
  ...props
}: DialogBoxProps): JSX.Element => {
  const dialogContainer = document.getElementById('dialog-container');

  if (!dialogContainer || !isOpen) {
    return <div />;
  }

  return createPortal(
    <Styles.Dialog {...props}>
      <Styles.Box id="dialog-modal" data-testid="dialog-modal">
        <Styles.CloseButton
          disabled={isSubmitting}
          aria-label="Close dialog"
          type="button"
          onClick={onCancelHandler}
        >
          <CancelIcon fontSize="small" />
        </Styles.CloseButton>
        <Styles.Header>
          <DeleteIcon />
          <Styles.Title>{title}</Styles.Title>
        </Styles.Header>
        <Styles.Text>{bodyText}</Styles.Text>
        <Styles.Footer>
          <Button
            data-testid="delete-modal-confirm-button"
            disabled={isSubmitting}
            size="medium"
            variantStyle="filled"
            variantColor="red"
            type="button"
            onClick={onConfirmHandler}
          >
            Yes, delete it
          </Button>
          <Button
            disabled={isSubmitting}
            variantStyle="outline"
            type="button"
            onClick={onCancelHandler}
          >
            Cancel
          </Button>
        </Styles.Footer>
      </Styles.Box>
    </Styles.Dialog>,
    dialogContainer
  );
};

export default DialogBox;
